
import { Pencil, Trash2 } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Project } from "../types";

interface ProjectTableProps {
  projects: Project[];
  selectedProjectId: string | null;
  onLoadProject: (project: Project) => void;
  onEditProject: (project: Project) => void;
  onDeleteProject: (project: Project) => void;
  canEditProject?: boolean;
  canDeleteProject?: boolean;
}

export const ProjectTable = ({ 
  projects, 
  selectedProjectId,
  onLoadProject, 
  onEditProject, 
  onDeleteProject,
  canEditProject = true,
  canDeleteProject = true
}: ProjectTableProps) => {
  const editDisabled = !canEditProject;
  const deleteDisabled = !canDeleteProject;
  return (
    <Card className="bg-secondary-light/5 border-2 border-primary">
      <CardContent className="p-4">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-primary-light font-medium text-left text-[10px] py-2" style={{
                fontSize: "11px"
              }}>Project Name</TableHead>
              <TableHead className="text-primary-light font-medium text-left text-[10px] py-2" style={{
                fontSize: "11px"
              }}>Description</TableHead>
              <TableHead className="text-primary-light font-medium text-left text-[10px] py-2" style={{
                fontSize: "11px"
              }}>Project Lead</TableHead>
              <TableHead className="text-primary-light font-medium text-left text-[10px] py-2" style={{
                fontSize: "11px"
              }}>Template</TableHead>
              <TableHead className="text-primary-light font-medium text-left text-[10px] py-2" style={{
                fontSize: "11px"
              }}>Start Date</TableHead>
              <TableHead className="text-primary-light font-medium text-left text-[10px] py-2" style={{
                fontSize: "11px"
              }}>End Date</TableHead>
              <TableHead className="text-primary-light font-medium text-left text-[10px] py-2" style={{
                fontSize: "11px"
              }}>Duration</TableHead>
              <TableHead className="text-primary-light font-medium text-left text-[10px] py-2" style={{
                fontSize: "11px"
              }}>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {projects.map(project => (
              <TableRow 
                key={project.id} 
                className={`cursor-pointer hover:bg-gray-700/30 ${selectedProjectId === project.id ? 'bg-white text-black hover:bg-white text-[10px]' : ''}`}
                onClick={() => onLoadProject(project)}
              >
                <TableCell className={`font-medium ${selectedProjectId === project.id ? 'text-black' : 'text-white'}`} style={{
                  fontSize: "11px"
                }}>{project.name}</TableCell>
                <TableCell className={`${selectedProjectId === project.id ? 'text-black' : 'text-gray-300'}`} style={{
                  fontSize: "11px"
                }}>{project.description}</TableCell>
                <TableCell className={`${selectedProjectId === project.id ? 'text-black' : 'text-gray-300'}`} style={{
                  fontSize: "11px"
                }}>{project.projectLead}</TableCell>
                <TableCell className={`${selectedProjectId === project.id ? 'text-black' : 'text-primary'}`} style={{
                  fontSize: "11px"
                }}>{project.template || "Custom"}</TableCell>
                <TableCell className={`${selectedProjectId === project.id ? 'text-black' : 'text-gray-300'}`} style={{
                  fontSize: "11px"
                }}>{project.startDate || "-"}</TableCell>
                <TableCell className={`${selectedProjectId === project.id ? 'text-black' : 'text-gray-300'}`} style={{
                  fontSize: "11px"
                }}>{project.endDate || "-"}</TableCell>
                <TableCell className={`${selectedProjectId === project.id ? 'text-black' : 'text-gray-300'}`} style={{
                  fontSize: "11px"
                }}>{project.duration ? `${project.duration} days` : "-"}</TableCell>
                <TableCell>
                  <div className="flex items-center gap-2">
                    <Button 
                      variant="ghost" 
                      size="sm" 
                      className="h-8 w-8 p-0" 
                      disabled={editDisabled}
                      onClick={e => {
                        e.stopPropagation();
                        onEditProject(project);
                      }}
                    >
                      <Pencil className={`h-4 w-4 ${editDisabled ? 'text-gray-400' : selectedProjectId === project.id ? 'text-black' : 'text-primary'}`} />
                    </Button>
                    <Button 
                      variant="ghost" 
                      size="sm" 
                      className="h-8 w-8 p-0" 
                      disabled={deleteDisabled}
                      onClick={e => {
                        e.stopPropagation();
                        onDeleteProject(project);
                      }}
                    >
                      <Trash2 className={`h-4 w-4 ${deleteDisabled ? 'text-gray-400' : selectedProjectId === project.id ? 'text-black' : 'text-primary'}`} />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
